import React, { useEffect, useState } from "react";

import { Alert, Button, Col, Row } from "@intech/web-ui";

import { ProcessoBeneficioEntidade } from "@entidades";
import { ProcessoBeneficioService } from "@services";
import { SaldoInicial } from "./SaldoInicial";
import { SaldoAtualizado } from "./SaldoAtualizado";
import { Historico } from "./Historico";
import { SaldoBD } from "./SaldoBD";
import { HistoricoBD } from "./HistoricoBD";
import { LoadingComponent, Beneficiarios } from "@components";
import { Informativos } from "./Informativos";

interface IProps {
  beneficio: ProcessoBeneficioEntidade | null | undefined
}

export const Beneficio: React.FC<IProps> = ({
  beneficio
}) => {
  const [AlertText, setAlertText] = useState<string>("");
  const [Extrato, setExtrato] = useState<any[] | null>(null);
  const [Loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    (async () => {
      try {
        // setLoading(true);
        // if (beneficio !== undefined && beneficio !== null) {
        const extrato = await ProcessoBeneficioService.BuscarExtratoAssistidoPorPlanoEspecieNumeroProcessoAnoProcesso(
          beneficio?.CD_PLANO!, beneficio?.CD_ESPECIE!, beneficio?.NUM_PROCESSO!, beneficio?.ANO_PROCESSO!
        );
        setExtrato(extrato);
        // }
        // setLoading(false);
      }
      catch (e) {
        setAlertText(e.response ? e.response.data : e);
        // setLoading(false);
      }
    })();
  }, []);

  async function gerarRelatorio() {
    try {
      setAlertText("");

      var relatorio = await ProcessoBeneficioService.GerarRelatorioExtratoCD(beneficio?.CD_PLANO!, beneficio?.CD_ESPECIE!, beneficio?.NUM_PROCESSO!, beneficio?.ANO_PROCESSO!, false)

      if (navigator.msSaveBlob) { // IE10+ : (has Blob, but not a[download] or URL)
        return navigator.msSaveBlob(new Blob([relatorio]), "extrato.pdf");
      } else {
        const url = window.URL.createObjectURL(new Blob([relatorio]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'extrato.pdf');
        document.body.appendChild(link);
        link.click();
      }
    }
    catch (e) {
      const error = e.response ? e.response.data : e;
      console.log(error);
      setAlertText(error);
    }
  }

  // if (Loading) {
  //   return (
  //     <LoadingComponent />
  //   )
  // }

  if (AlertText !== "") {
    return (
      <Alert type={"danger"}>
        {AlertText}
      </Alert>
    )
  }

  if (Extrato !== null) {
    if (Extrato.length > 0) {
      if (beneficio?.CD_PLANO! === "0001") {
        return (
          <>
            <SaldoBD saldo={Extrato[0]} />

            <Beneficiarios />

            <Informativos />

            <HistoricoBD saldo={Extrato} />
          </>
        );
      }
      return (
        <>
          <Row
            className={"mb-3"}>
            <Col>
              <Button
                onClick={gerarRelatorio}
                title={"Gerar Extrato em PDF"}
                type={"primary"}
                loadingText={"Baixando..."}
                usesLoading
                block
              />
            </Col>
          </Row>

          <SaldoInicial saldo={Extrato[0]} primeiraCota={Extrato[Extrato.length - 1].VALOR_IND} />

          <SaldoAtualizado saldo={Extrato[0]} />

          <Beneficiarios />

          <Informativos />

          <Historico saldo={Extrato} />
        </>
      )
    }
    return (
      <Alert type={"danger"}>
        {"Nenhum processo de benefício encontrado para esse plano."}
      </Alert>
    )
  }

  // if (Loading === false && Extrato === null) {
  //   return (
  //     <Alert type={"danger"}>
  //       {"Nenhum processo de benefício encontrado para esse plano."}
  //     </Alert>
  //   )
  // }

  return (
    <LoadingComponent />
  )

  // return null;

}